import { useContext, useEffect, useState } from "react";
import { AxiosResponse } from "axios";

import { EPTable } from "../../../common/controls";
import { Row, Col, Card, Button } from "react-bootstrap";
import { axiosGet } from "../../../common/utils/helper";
import { meetingCredentials } from "../../../common/utils/api";
import { UserContext } from "../../layout/layout";
import { CommonConstants } from "../../../common/utils/CommonConstants";
import AddMeetingCredentials from "./addMeetingCredentials";

interface Credential {
  ScheduleType: number;
  Credentials: string;
}

const MeetingCredentials = () => {
  const { user }: any = useContext(UserContext);
  const PageAccess: string[] =
    user.RoleAccess[location.pathname?.split("/").join("").toLowerCase()];
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [refresher, setRefresher] = useState<boolean>(false);
  const [credentials, setCredentials] = useState<Credential[]>([]);

  const tableColumns = [
    {
      key: "Action",
      label: "Action",
      width: 100,
    },
    {
      key: "ScheduleType",
      label: "Platform",
      resizable: true,
      width: 350,
    },
    {
      key: "Credentials",
      label: "Credentials",
      resizable: true,
      width: 350,
      flexGrow: 1,
    },
  ];

  const getMeetingCredentials = async (reqUrl: string) => {
    setLoading(true);
    let response = (await axiosGet(reqUrl)) as AxiosResponse;
    if (
      response &&
      response.status === CommonConstants.API_RESPONSE_SUCCESSFULL
    ) {
      setLoading(false);
      setCredentials(response?.data?.data?.data);
    }
  };

  const handleAddProjectModal = () => {
    setOpen(true);
  };

  useEffect(() => {
    getMeetingCredentials(meetingCredentials);
  }, [refresher]);

  return (
    <Card className="card-managerequest">
      <Card.Body>
        <div>
          {open && (
            <AddMeetingCredentials
              open={open}
              setOpen={setOpen}
              action={"Add"}
              setRefresher={setRefresher}
              refresher={refresher}
            />
          )}
        </div>
        <Row className="mb-3">
          {(PageAccess?.includes("Add") || PageAccess?.includes("All")) && (
            <Col xs lg="3" className="text-end ms-auto">
              <Button
                type="button"
                className="primarybtn mt-2"
                onClick={handleAddProjectModal}
              >
                Add Platform
              </Button>
            </Col>
          )}
        </Row>
        <EPTable
          setLoading={setLoading}
          PageAccess={PageAccess}
          listName="MeetingConfig"
          columns={tableColumns}
          data={credentials}
          loading={loading}
          rowHeight={40}
          height={455}
          refresher={refresher}
          setRefresher={setRefresher}
        />
      </Card.Body>
    </Card>
  );
};

export default MeetingCredentials;
